import { Typo3Link } from '@/types/typo3'
import { BaseLinkProps } from '@/ui/components/types/base'

const toBaseLink = (link: Typo3Link) =>
  <BaseLinkProps>{
    children: link.linkText,
    nextLink: !link.target || link.target === '_blank' ? false : true,
    href: link?.href || '',
    target: link?.target || '',
    className: link?.class || ''
  }

export default toBaseLink
